import $ from "jquery";
import { convertHexStringToBitMask } from 'utils';

$(() => {
    const bitmask = convertHexStringToBitMask($('#schedule').val());
    $('#skoleskema td')
        .filter((_, element) => bitmask[$(element).data('bit')])
        .addClass('selected');

    const $tables = $('.skoleskema');
    const highContrastCookie = $.cookie('highContrast') === 'true';
    if (highContrastCookie) {
        $tables.addClass('highContrast');
    } else {
        $tables.removeClass('highContrast');
    }
});
